import { Modal } from '@tcl-boron-prefabs/modal';
import * as typography from '@tcl-boron-styles/typography/dist/index.module.scss';
import cn from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  countdownSeconds: number;
  onContinue: () => void;
  onLogout: () => void;
}

const useStyles = createUseStyles({
  content: {
    marginBottom: '24px',
  },
  messageText: {
    margin: '12px 0',
  },
  countdownText: {
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    marginTop: '24px',
  },
});

const formatTimeRemaining = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  countdownSeconds,
  onContinue,
  onLogout,
}) => {
  const classes = useStyles();

  return (
    <>
      <Modal
        isOpen={isOpen}
        size="small"
        title="Session expiring"
        onRequestClose={() => {}}
        shouldCloseOnOverlayClick={false}
        callToActionButton={{
          id: 'continue-session',
          buttonText: 'Extend session',
          onClick: onContinue,
        }}
        cancelButton={{
          id: 'logout',
          buttonText: 'Logout',
          onClick: onLogout,
        }}
      >
        <div className={classes.content}>
          <div className={cn(typography.body, classes.messageText)}>
            <span>
              Your session is about to expire due to inactivity. To protect your information, you’ll be logged out
              in{' '}
            </span>
            <span className={classes.countdownText}>{formatTimeRemaining(countdownSeconds)}</span>.
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SessionTimeoutModal;
